<template>
  <v-app id="app" class="background">
    <div>
      <!--DRAWER-->
      <drawer></drawer>
      <!--MENU-->
      <menu-client></menu-client>
      <v-content class="background">
        <v-fade-transition mode="out-in">
          <router-view />
          <welcome></welcome>
        </v-fade-transition>
      </v-content>
    </div>
    <open-security></open-security>
    <open-wallet></open-wallet>
    <alert></alert>
    <open-pin></open-pin>
    <spin></spin>
    <bank-account></bank-account>
    <open-transfer-wallet></open-transfer-wallet>
    <pin-confirm></pin-confirm>
    <pin-to-charge-wallet></pin-to-charge-wallet>
    <open-modal-transaction-client v-if="this.$store.getters.getAllCTransactions.length"></open-modal-transaction-client>
  </v-app>
</template>

<script>
import Drawer from "../components/dashboard/Drawer";
import OpenSecurity from "../components/tools/OpenSecurity";
import OpenWallet from "../components/tools/OpenChargeWallet";
import Welcome from "../components/welcome/Welcome";
import Alert from "../components/tools/Alert";
import OpenPin from "../components/tools/OpenPin";
import Spin from "../components/tools/Spin";
import BankAccount from "../components/tools/BankAccount";
import OpenTransferWallet from "../components/dashboard/client/wallet/OpenTransferWallet";
import PinConfirm from "../components/dashboard/client/tools/PinConfirm";
import PinToChargeWallet from "../components/dashboard/client/tools/PinToChargeWallet";
import MenuClient from "@/components/dashboard/client/MenuClient";
import OpenModalTransactionClient from "@/components/dashboard/client/tools/OpenModalTransactionClient";

export default {
  name: "Home",
  components: {
    OpenModalTransactionClient,
    MenuClient,
    PinToChargeWallet,
    PinConfirm,
    OpenTransferWallet,
    BankAccount,
    Spin,
    OpenPin,
    Alert,
    Welcome,
    drawer: Drawer,
    "open-security": OpenSecurity,
    "open-wallet": OpenWallet
  },

  data: () => ({
    centered: false,
    grow: false,
    right: false
  })
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>
